import isEprEditable from "../../../utils/ActionControls/isEprEditable";

/**
 * Per-student editability for the differentiated bulk grid.
 * Groups uses that student's gradingProfileStatus (same as RatingGridBody).
 * Homeroom uses the selected EPR. VIEW permission is student.canEdit.
 */
export const isDiffStudentEditable = ({ student, mode, isActiveWindow, selectedEpr, userDetails }) => {
    if (!student?.canEdit) return false;
    const status = mode === "GROUPS" ? student.gradingProfileStatus : selectedEpr?.status;
    return isEprEditable({ isActiveWindow, status, userDetails });
};
